'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warningSignalUrl = exports._tyUrl = undefined;

var _Coder = require('./Coder');

var tyBaseUrl = window.PAGE_CONFIG.BASE_URL + '/fenglingzixun/',
    tyComUrl = '/user/post/,/';

var _tyUrl = exports._tyUrl = {
  obtain: function obtain() {
    return tyBaseUrl + _Coder.Coder.encode('typhoonspot/obtain' + tyComUrl);
  },
  add: function add() {
    return tyBaseUrl + _Coder.Coder.encode('typhoonspot/add' + tyComUrl);
  },
  remove: function remove() {
    return tyBaseUrl + _Coder.Coder.encode('typhoonspot/remove' + tyComUrl);
  },
  modify: function modify() {
    return tyBaseUrl + _Coder.Coder.encode('typhoonspot/modify' + tyComUrl);
  }
};

var warningSignalUrl = exports.warningSignalUrl = tyBaseUrl + _Coder.Coder.encode('remindarea/findByType/user/post/,/post');


//////////////////
// WEBPACK FOOTER
// ./js/util/url.conf.js
// module id = 22
// module chunks = 0